/**
 * This is simple JWT API for testing purposes.
 * https://github.com/pinia-studio/jwt-api-node
**/

export const JWT_HOST_API = "https://jwt-api-node.vercel.app";

export const KEYCLOAK_CONFIG = {
    url: "https://auth.dev.henddu.com",
    realm: "henddu",
    clientId: "henddu-client"
  };